export const FETCH_USER_RECURRING_RECEIVABLES_REQUEST =
  'FETCH_USER_RECURRING_RECEIVABLES_REQUEST';
export const FETCH_USER_RECURRING_RECEIVABLES_SUCCESS =
  'FETCH_USER_RECURRING_RECEIVABLES_SUCCESS';
export const FETCH_USER_RECURRING_RECEIVABLES_FAILURE =
  'FETCH_USER_RECURRING_RECEIVABLES_FAILURE';
export const CANCEL_RECURRING_RECEIVABLE_REQUEST =
  'CANCEL_RECURRING_RECEIVABLE_REQUEST';
export const CANCEL_RECURRING_RECEIVABLE_SUCCESS =
  'CANCEL_RECURRING_RECEIVABLE_SUCCESS';
export const CANCEL_RECURRING_RECEIVABLE_FAILURE =
  'CANCEL_RECURRING_RECEIVABLE_FAILURE';
export const RECURRING_RECEIVABLE_CANCELLED_STATUS = 'cancelled';
